import noUiSlider from 'nouislider';

import Component from '../../component/component';
import Helpers from '../../helpers/helpers';

import 'nouislider/dist/nouislider.css';
import './range.scss';

type WrappedSubRange = [number] | [number, number];
type SubRange = number | WrappedSubRange;
interface ISliderRange {
    min: SubRange;
    max: SubRange;

    [key: `${number}%`]: SubRange;
}

export default class Range extends Component {
    static initSelector: string = '.range';

    input: JQuery;
    min: number;
    max: number;
    step: number;
    values: number[];
    slider: JQuery;
    unitInEuros: JQuery;
    currencyRate: number;

    // eslint-disable-next-line
    sliderContainer: any;

    constructor(target: HTMLElement) {
        super(target);

        this.input = this.element.find('.range__input');
        this.min = Number(this.input.attr('min'));
        this.max = Number(this.input.attr('max'));
        this.step = Number(this.input.attr('step'));
        this.values = this.input.attr('values').split(',').map((value: string) => Number(value));
        this.slider = this.element.find('.range__slider');
        this.unitInEuros = this.element.find('.range__unit-secondary-value');

        const rateFromData: string = this.element.attr('data-primary-to-secondary-rate');

        this.currencyRate = rateFromData ? Number(rateFromData) : 1.95583;

        this.init();
    }

    init(): void {
        let range: ISliderRange;

        if (this.values.length > 1) {
            const segmentPercent: number = (100 / (this.values.length - 1));

            for (let i: number = 0; i < this.values.length - 1; i++) {
                if (i === 0) {
                    range = {
                        min: [this.values[i], this.values[i+1] - this.values[i]],
                        max: [this.values[this.values.length - 1]],
                    };
                } else {
                    range[(segmentPercent * i).toString() + '%'] = [this.values[i], this.values[i+1] - this.values[i]];
                }
            }
        } else {
            range = {
                min: this.min,
                max: this.max,
            };
        }

        this.sliderContainer = noUiSlider.create(this.slider.get(0), {
            connect: this.element.hasClass('range--connect') ? 'lower' : false,
            range,
            start: [<string> this.input.val()],
            step: this.step,
        });

        this.sliderContainer.on('slide', this.handleSlide.bind(this));
        this.input.on('change', this.handleChange.bind(this));
        this.input.on('keypress', (event: JQuery.TriggeredEvent): boolean => event.which !== 13);
    }

    handleSlide(): void {
        let value: number = this.sliderContainer.get(true);

        // round value
        if (Helpers.isInt(this.step)) {
            value = Math.round(value);
        }

        const valueInEuros: number = (value / this.currencyRate);

        this.input.val(value);
        this.unitInEuros.text(valueInEuros.toFixed(2));
    }

    handleChange(): void {
        let value: number = <number> this.input.val();

        // round value
        value = Math.round(value);

        if (value < this.min) {
            value = this.min;
        }

        if (value > this.max) {
            value = this.max;
        }

        // round value
        if (Helpers.isInt(this.step)) {
            value = Math.round(value);
        }

        // update input and slider
        this.input.val(value);
        this.sliderContainer.set(value);
    }
}
